import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/company/jiulinghistory.jpg';
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "pb-40"
};
const _hoisted_3 = {
  class: "detail-title"
};
const _hoisted_4 = {
  class: "detail-content"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "pb-60",
  src: _imports_0,
  alt: "久灵发展历史"
}, null, -1);
const _hoisted_6 = {
  class: "company-introduction-title"
};
const _hoisted_7 = {
  class: "row"
};
const _hoisted_8 = {
  class: "company-introduction-content content-left"
};
const _hoisted_9 = {
  class: "company-introduction-content content-right"
};
const _hoisted_10 = {
  class: "pt-60"
};
const _hoisted_11 = {
  class: "pt-60"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MixImageSwiperVue = _resolveComponent("MixImageSwiperVue");
  const _component_MixImageSwiperVue1 = _resolveComponent("MixImageSwiperVue1");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("about.jiuling.title")), 1), _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("about.jiuling.content")), 1)]), _hoisted_5, _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("jiuling.companyIntroductions")), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("jiuling.companyIntroduction.p1")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("jiuling.companyIntroduction.p2")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("jiuling.companyIntroduction.p3")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("jiuling.companyIntroduction.p4")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("jiuling.companyIntroduction.p5")), 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("jiuling.companyIntroduction.p6")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("jiuling.companyIntroduction.p7")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("jiuling.companyIntroduction.p8")), 1)])]), _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t("jiuling.enterpriseHonor")), 1), _createVNode(_component_MixImageSwiperVue, {
    file: "company/enterpriseHonor/"
  }), _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("jiuling.companyEnvironment")), 1), _createVNode(_component_MixImageSwiperVue1, {
    file: "company/companyEnvironment/",
    class: "pb-60",
    swiperNum: 2,
    ImageNum: 3
  })]);
}